export default __webpack_public_path__ + "static/media/cleavelandBrownsVideo-2x.f0febbfd.jpg";